export enum ExchangeFormEventNames {
    FORM_DATA_UPDATED = 'FORM_DATA_UPDATED',
}
